// SAFE MODE: delivery sessions improvements
// Service for secure album download flow - edge functions only

const SUPABASE_URL = import.meta.env?.VITE_SUPABASE_URL;
const SUPABASE_ANON = import.meta.env?.VITE_SUPABASE_ANON_KEY;

/**
 * Create secure album link - calls create-secure-album-link edge function
 * @param {string} deliveryId - delivery ID
 * @param {string} accessToken - Supabase auth access token
 * @returns {Promise<{ ok: boolean, url?: string, message?: string }>}
 */
export async function createSecureAlbumLink(deliveryId, accessToken) {
  const res = await fetch(`${SUPABASE_URL}/functions/v1/create-secure-album-link`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`,
      'apikey': SUPABASE_ANON || '',
    },
    body: JSON.stringify({ delivery_id: deliveryId }),
  });
  return res.json();
}

/**
 * Verify album token and get metadata - for external download page
 * @param {string} token - JWT token from URL
 * @returns {Promise<{ ok: boolean, delivery?: object, files?: array, message?: string }>}
 */
export async function verifyAlbumToken(token) {
  const res = await fetch(`${SUPABASE_URL}/functions/v1/verify-album-token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'apikey': SUPABASE_ANON || '',
    },
    body: JSON.stringify({ token }),
  });
  return res.json();
}

/**
 * Trigger ZIP download - returns blob URL for browser download
 * @param {string} token - JWT token
 * @param {string} type - 'full' | 'photos' | 'videos'
 * @returns {Promise<{ ok: boolean, blob?: Blob, fileName?: string, message?: string }>}
 */
export async function downloadAlbumZip(token, type = 'full') {
  const res = await fetch(`${SUPABASE_URL}/functions/v1/download-album-zip`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'apikey': SUPABASE_ANON || '',
    },
    body: JSON.stringify({ token, type }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    return { ok: false, message: err?.message || 'فشل التحميل' };
  }

  const blob = await res.blob();
  const disposition = res.headers.get('Content-Disposition');
  let fileName = 'album.zip';
  if (disposition) {
    const match = disposition.match(/filename="?([^";]+)"?/);
    if (match) fileName = match[1];
  }
  return { ok: true, blob, fileName };
}
